import { h } from "preact";
import { observer } from "mobx-react";
function FieldHint(props) {
    const { message, id, extraClasses = "" } = props;
    if (message.length === 0)
        return null;
    return (h("p", { id: id, class: `help-block u-color-inherit ${extraClasses}` }, message));
}
export default observer(FieldHint);
